import { getFeature } from "@asurion-core/expert-workspace-feature-flagging";
export const LOGIN_POPUP_DEFAULT = true;
export const LOGIN_POPUP_AUTO_CLOSE_DEFAULT = true;
export interface LoginPopupConfig {
    loginPopup: boolean;
    loginPopupAutoClose: boolean;
}

export async function getAmazonConnectLoginPopupConfig(
    source: "EVL" | "ExWo",
    context: {
        environment: string;
        channel: string;
        employeeId: string;
    },
): Promise<LoginPopupConfig> {
    const loginPopup = (await getFeature<boolean>(`${source}-loginPopup`, context)) ?? LOGIN_POPUP_DEFAULT;
    const loginPopupAutoClose =
        (await getFeature<boolean>(`${source}-loginPopupAutoClose`, context)) ?? LOGIN_POPUP_AUTO_CLOSE_DEFAULT;
    return { loginPopup, loginPopupAutoClose };
}
